import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Sidebar from './MainLayout/Drawer/SidebarRefactored';
import Header from './MainLayout/Header';
import { openDrawer } from '../store/reducers/menu';

const MainLayout = () => {
  const dispatch = useDispatch();
  const { drawerOpen } = useSelector((state) => state.menu);
  const [open, setOpen] = useState(true);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    dispatch(openDrawer({ drawerOpen: true }));
  }, [dispatch]);

  const handleDrawerToggle = () => {
    const newOpen = !open;
    setOpen(newOpen);
    dispatch(openDrawer({ drawerOpen: newOpen }));
  };

  useEffect(() => {
    if (open !== drawerOpen) setOpen(drawerOpen);
  }, [drawerOpen, open]);

  const sidebarWidth = collapsed ? 64 : 256;

  return (
    <div className="flex min-h-screen">
      <Sidebar open={open} onToggle={handleDrawerToggle} onCollapsedChange={setCollapsed} />
      <div className="flex flex-col flex-1">
        <Header open={open} sidebarWidth={sidebarWidth} collapsed={collapsed} />
        <main 
          className="flex-1 p-6 pt-20 transition-all duration-300 bg-gray-50/50"
          style={{
            marginLeft: open ? `${sidebarWidth}px` : '0'
          }}
        >
          <div className="w-full h-full flex flex-col">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;